import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { store } from './store/store';
import theme from './theme';
import Routes from './routes/Routes';
import AppConfigProvider from './components/AppConfigProvider';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { tracker } from '@openreplay/tracker';

tracker.configure({
  projectKey: import.meta.env.VITE_OPENREPLAY_PROJECT_KEY,
});

const App = () => {
  useEffect(() => {
    if (window.location.hostname !== 'localhost') {
      tracker.start();
      ReactPixel.init(import.meta.env.VITE_META_PIXEL);
      ReactPixel.pageView();
    }
  }, [])

  return (
    <AppConfigProvider>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <HelmetProvider>
            <Routes />
          </HelmetProvider>
        </Provider>
      </ThemeProvider>
    </AppConfigProvider>
  );
};

export default App;
